// Module
var code = "<div class=\"abx-field-preloader__label\" ng-class=\"{\n    sm: vm.labelSize === 'small',\n    md: vm.labelSize === 'medium',\n    lg: vm.labelSize === 'large'\n  }\"></div> <div class=\"abx-field-preloader__field\"> <div class=\"abx-field-preloader__text\"></div> </div> ";
// Exports
module.exports = code;